import React from 'react';
import { useWindowSize } from '../../hooks/useWindowSize';
import './style.css'

const ScreenRotationWarning = ({
  userInputtingText,
  logoImageUrl
}) => {
  const screenSize = useWindowSize();
    return <>
    {(!userInputtingText && (screenSize.height < 300 )) && 
    <div className="screenWarning">
      <img className="logo" src={logoImageUrl} alt="Logo" />
      <h3>Please rotate your screen to portrait</h3>
    </div>}
    </>
}

export default ScreenRotationWarning;